import { Post } from './http.js';
import { Get } from './http.js';
import { Put } from './http.js';
import { Delete } from './http.js';

/*** 调用接口地址 START ***/
export const ApiUrl = {//导出
    exportPersonalPointDetailsList: '/personal/handsel_listdc',//导出个人金豆明细

};
/*** 调用接口地址 END ***/

/*** Axois调用接口 START ***/
export const Apis = {
    //公共
    getCategoryList: data => Get('/category/indexpz', data), // 获取分类

};
/*** Axois调用接口 END ***/



// WEBPACK FOOTER //
// ./src/api/api.js